import { ErrorState } from "@dexibit/core";

import { Styled404Container } from "../styles";

const UnauthorizedPage = () => {
  return (
    <Styled404Container>
      <ErrorState
        title="You don't have access to this page"
        fullScreen={false}
        transparent
      />
    </Styled404Container>
  );
};

export default UnauthorizedPage;
